import { FETCH_CURRENT_CAMPAIGN_BEGIN,
  FETCH_CURRENT_CAMPAIGN_SUCCESS,
  FETCH_CURRENT_CAMPAIGN_FAILURE,
  SET_TOOLBAR_VISIBILITY, SET_DISPLAYED_INFLUENCER,
  SET_CURRENT_TOOLBAR_KEY,
  SET_DISPLAYED_SOCIAL_PROFILE
} from '../actions/currentCampaign';
const initialState = {
  campaign: {},
  loading: false,
  error: null
};

export default function currentCampaign(state = initialState, action) {
  switch (action.type) {
  case FETCH_CURRENT_CAMPAIGN_BEGIN:
    // Mark the state as "loading" so we can show a spinner or something
    // Also, reset any errors. We're starting fresh.
    return {
      ...state,
      loading: !action.opts.skip_loading,
      error: null
    };

  case FETCH_CURRENT_CAMPAIGN_SUCCESS:
    // All done: set loading "false".
    // Also, replace the items with the ones from the server
    return {
      ...state,
      campaign: action.payload.campaign,
      loading: false,
      error: null
    };

  case FETCH_CURRENT_CAMPAIGN_FAILURE:
    return {
      ...state,
      loading: false,
      error: action.payload.error,
      campaign: { id: state.currentCampaign.id }
    };
  case SET_TOOLBAR_VISIBILITY:
    return {
      ...state,
      toolbarVisibility: action.toolbarVisibility
    };
  case SET_DISPLAYED_INFLUENCER:
    return {
      ...state,
      toolbarVisibility: true,
      displayedInfluencer: action.displayedInfluencer,
      currentToolbarKey: 'user',
      displayedInfluencerTab: action.displayedInfluencerTab
    };
  case SET_DISPLAYED_SOCIAL_PROFILE:
    return {
      ...state,
      toolbarVisibility: true,
      displayedSocialProfile: action.displayedSocialProfile,
      currentToolbarKey: 'social_profile',
      displayedProfileTab: action.displayedProfileTab
    };
  case SET_CURRENT_TOOLBAR_KEY:
    return {
      ...state,
      toolbarVisibility: true,
      currentToolbarKey: action.key
    };
  default:
      // ALWAYS have a default case in a reducer
    return state;
  }
}
